module.exports = __webpack_public_path__ + "img/full5-min.7675c761.png";